<template>
	<headerView></headerView>
	<RouterView />
	<footerView></footerView>
</template>

<script>
	import headerView from './components/headerView.vue'
	//import indexView from './components/indexView.vue'
	import footerView from './components/footerView.vue'
	export default {
		name: 'App',
		components: {
			headerView,
			//indexView,
			footerView
		}
	}
</script>

<style>

</style>